// Auto-generated file

import { lazy } from "react";

const SCREEN_COMPONENTS: Record<string, React.ComponentType> = {
  login: lazy(() => import("@/screens/login")),
  "login-id": lazy(() => import("@/screens/login-id")),
  "login-password": lazy(() => import("@/screens/login-password")),
  "signup-id": lazy(() => import("@/screens/signup-id")),
  "reset-password-request": lazy(() => import("@/screens/reset-password-request")),
  "mfa-otp-challenge": lazy(() => import("@/screens/mfa-otp-challenge")),
  "email-identifier-challenge": lazy(() => import("@/screens/email-identifier-challenge")),
  "reset-password": lazy(() => import("@/screens/reset-password")),
  "reset-password-success": lazy(() => import("@/screens/reset-password-success")),
};

export const getScreenComponent = (
  screenName: string | undefined
): React.ComponentType | null => {
  if (!screenName) {
    return null;
  }
  return SCREEN_COMPONENTS[screenName] || null;
};
